var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row"},[_c('router-view',{staticClass:"w-full"}),_vm._v(" "),_c('sweet-modal',{ref:"not_available",attrs:{"icon":"warning","overlay-theme":"dark"}},[_vm._v("\n        This feature is not yet available\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }